import { useEffect } from 'react';
import { useAuth } from '@/contexts/useAuth';
import { disconnectSharedSocket, useRealtimeSync } from '@/hooks/useRealtimeSync';

export function RealTimeSync() {
  const { isAuthenticated, loading } = useAuth();
  const syncActive = !loading && isAuthenticated;
  useRealtimeSync(syncActive);

  useEffect(() => {
    if (loading) return;
    if (!isAuthenticated) {
      disconnectSharedSocket();
    }
  }, [loading, isAuthenticated]);

  return null;
}
